import React from "react";
import { useLocation } from "react-router-dom";
import { useSklad } from "./SkladContext";
import "./SkladBar.css";

// Bu sahifalarda sklad filtri ko'rsatilmaydi
const EXCLUDED_SEGMENTS = ["Sozlamalar", "accauntlar", "Ombor"];

export default function SkladBar() {
  const { pathname } = useLocation();
  const { activeSklad, setActiveSklad, sklads } = useSklad();

  const isExcluded = EXCLUDED_SEGMENTS.some((seg) =>
    pathname.endsWith("/" + seg)
  );

  // Faqat 2 va undan ko'p sklad bo'lganda ko'rsatamiz
  if (isExcluded || sklads.length < 2) return null;

  return (
    <div className="sklad-bar">
      <span className="sklad-bar-label">Do'kon:</span>
      <div className="sklad-bar-chips">
        <button
          className={"sb-chip" + (activeSklad === "all" ? " sb-active" : "")}
          onClick={() => setActiveSklad("all")}
        >
          Barchasi
        </button>
        {sklads.map((s) => {
          const isActive = String(activeSklad) === String(s.id);
          return (
            <button
              key={s.id}
              className={"sb-chip" + (isActive ? " sb-active" : "")}
              onClick={() => setActiveSklad(String(s.id))}
            >
              {s.rasm ? (
                <img src={s.rasm} alt="" className="sb-chip-img" />
              ) : (
                <span className="sb-chip-letter">
                  {s.nom?.[0]?.toUpperCase() || "?"}
                </span>
              )}
              {s.nom}
            </button>
          );
        })}
      </div>
    </div>
  );
}
